<template>
    <json-formatter
      v-if="certDetails"
      :data="certDetails"
      path="res"
    />
</template>

<script>
import JsonFormatter from 'vue-json-pretty';

export default {
  name: "ClientCertificateDetails",
  components: {
    JsonFormatter
  },
  props: {
    userId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      certDetails: null,
    };
  },
  mounted() {
    this.$http
    .get(
      `${this.$store.getters.baseUrl}/api/user/ClientCertificateDetails?userId=${this.userId}`
    )
    .then((result) => {
      this.certDetails = result.data;
    })
    .catch((error) => {
      this.$vs.notify({
        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
        text: this.$helpers.errorText(error),
        color: 'danger',
        time: this.$store.getters.notificationDuration,
      });
    });
  },
};
</script>
